export default "__VITE_ASSET__r6yf964Z__"